import Icons from './utils/Icons.js';
import ComponentFactory from './ComponentFactory.js';

class Main {
  constructor() {
    this.init();
  }

  init() {
    // Indique à tous les éléments que le javascript est activé grâce à une classe d'état
    document.documentElement.classList.add('has-js');

    Icons.load();
    new ComponentFactory();
  }
}
new Main();
